import styled from 'styled-components'

import { spacing } from '../../../../utils/ui/spacing'

export const TimeFrameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const ValueWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.tokens.interface.neutral.regular};
  border-radius: 4px;
  width: 100%;
  height: 100%;
  margin: 0 ${spacing('md')}px;
  padding: 0 ${spacing('md')}px;
`

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  padding: 0;
  background-color: inherit;
`
